import style from "../../../../assets/scss/sub/purchase/orderAndPayment.module.scss";
import {PaymentWay} from "../../../../types/payment";
import React from "react";

interface Args{
    paymentWay: PaymentWay | null,
    onClickPaymentWayBtn: (_: PaymentWay) => void
}
export function PaymentMethodField({paymentWay, onClickPaymentWayBtn}: Args) {
    return (
        <div className={style.paymentWay}>
            <h3 className={style.sectionTitle}>결제수단</h3>
            <ul className={style.ways}>
                <li
                    className={`${style.payItem} ${paymentWay === PaymentWay.CARD ? style.selected : ""}`}
                    onClick={() => onClickPaymentWayBtn(PaymentWay.CARD)}
                >
                    카드결제
                </li>
                <li
                    className={`${style.payItem} ${paymentWay === PaymentWay.VBANK ? style.selected : ""}`}
                    onClick={() => onClickPaymentWayBtn(PaymentWay.VBANK)}
                >
                    가상계좌
                </li>
            </ul>
        </div>
    )
}